import { Schema as S } from "effect";
export const Schema = S.String.pipe(// Loosen email validation to allow invalid emails being
// provided.
// S.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
S.brand("@open-revenue/schema/Email"));
export const Type = Schema.Type;
export const make = (id)=>S.decode(Schema)(id);
export const makeUnsafe = (id)=>id;
